// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import React, { memo, useEffect, useState } from 'react';
import styled from '@emotion/styled';

import AuthRichPageTemplate from 'presentations/views/components/templates/AuthRichPageTemplate';
import LoginForm from 'presentations/views/components/organisms/LoginForm';
import TeamLoginForm from 'presentations/views/components/organisms/TeamLoginForm';
import LoginLookupForm from 'presentations/views/components/organisms/LoginLookupForm';
import JoinTeamForm from 'presentations/views/components/organisms/JoinTeamForm';
import Snackbar from 'presentations/views/components/atoms/Snackbar';
import ProgressScreen from 'presentations/views/components/atoms/ProgressScreen';

import { useLoginPage, Props, Steps } from './hooks';

const Component = memo((props: Props) => {
  const t = translateInComponent(translations);
  const { state, actions } = useLoginPage(props);

  return (
    <AuthRichPageTemplate
      form={
        <>
          {state.activeStep === Steps.Lookup && (
            <LoginLookupForm
              isLoading={state.isLoading}
              email={state.email}
              onChange={actions.onChange}
              onSubmit={actions.onSubmitEmailLookup}
              onClickService={actions.onClickService}
              errors={state.errors}
              to={props.to}
              isMobileAppUser={props.isMobileAppUser}
            />
          )}
          {state.activeStep === Steps.TeamSelect && (
            <TeamLoginForm
              isLoading={state.isLoading}
              teams={state.teams}
              onClick={actions.onClickTeam}
            />
          )}
          {state.activeStep === Steps.Login && (
            <LoginForm
              isLoading={state.isLoading}
              isResetLoading={state.isResetLoading}
              email={state.email}
              password={state.password}
              providers={state.providers}
              loadingProvider={state.loadingProvider}
              onChange={actions.onChange}
              onSubmit={actions.onSubmitEmailPassword}
              onClickService={actions.onClickService}
              onClickResetPassword={actions.onClickResetPassword}
              errors={state.errors}
            />
          )}
          {state.activeStep === Steps.Starting && (
            <LoadingContainer>
              <ProgressScreen isOpen={true} message={t('starting')} />
              <MessageContainer>{t('starting')}</MessageContainer>
            </LoadingContainer>
          )}
          {state.activeStep === Steps.JoinTeam && (
            <JoinTeamForm
              isSubmitLoading={state.isLoading}
              teams={state.joinTeams}
              onClickJoinTeam={actions.onClickJoinTeam}
              teamName={state.teamName}
              isCheck={state.isCheckedAutoJoin}
              onSubmit={actions.onSubmitCreateTeam}
              onChange={actions.onChange}
              viewerDomain={state.viewerDomain}
            />
          )}
        </>
      }
      snackbar={
        !!state.message && (
          <Snackbar
            onClose={actions.onCloseMessage}
            isOpen={true}
            severity={state.severity}
            message={state.message}
          />
        )
      }
      headerHidden={
        props.isMobileAppUser &&
        state.activeStep !== Steps.Starting &&
        state.activeStep !== Steps.Lookup
      }
      footerHidden
    />
  );
});
export default Component;

const LoadingContainer = styled.div`
  position: static;
`;
const MessageContainer = styled.div`
  padding: 128px 0;
  text-align: center;
`;
